import { Activity } from "@ofqual/portal-activity-feed";
import { ActionType } from "./EventNotificationActivityFeedTypes";

export const buildActions = (
  showMessage: boolean,
  showDocument: boolean,
  action: (entity: ActionType | Activity | null) => void
) => {
  const sendMessage = {
    label: "Send Message",
    dataTest: "en-send-message",
    action: () => action(ActionType.SendMessage),
  };


  const attachDocument = {
    label: "Attach Document",
    dataTest: "attach-doc-notification-button",
    action: () => action(ActionType.AttachDocument),
  };

  let actions : any[] = [];

  if (showMessage) {
    actions = [...actions, sendMessage];
  }
  if (showDocument) {
    actions = [...actions, attachDocument];
  }

  return actions;
};
